export default function onSelectionApplied(grid, callback) {
	if (callback) {
		grid.bind("custom:selectionApplied", callback);
	}
}
